import request from '@/utils/request'

/**
 * 查看用户付费状态
 * @param {*} data
 *
 */
export function checkUserPayStatusAPI(data) {
    return request({
        url: `checkIsUserPaid`,
        method: 'post',
        data: data,
    })
}

/**
 * 获取付款链接
 * @param {*} data
 *
 */
export function getUserCheckoutAPI(data) {
    return request({
        url: `createCheckoutSession`,
        method: 'post',
        data: data,
    })
}

/**
 * 用户取消订阅
 * @param {*} data
 *
 */
export function cancelSubscriptionAPI(data) {
    return request({
        url: `cancelSubscription`,
        method: 'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/api/user/index.js